import React from 'react';
import { Provider } from 'react-redux';
import { compose } from 'redux';
import configureStore from '../../store';

import PersonalData from '../PersonalData';
import { withViewAnalytics } from '../../utils/hocs/withViewAnalytics';

const initComponent = () => {
  const store = configureStore();

  return (props) => (
    <Provider store={store}>
      <PersonalData {...props} />
    </Provider>
  );
};

export default compose(
  withViewAnalytics,
)(initComponent);
